module.exports = __webpack_public_path__ + "static/media/iconCheck2.320d3070.svg";